'use strict';

/*global blockElement*/
/*global unBlockElement*/
(function ($) {
  function openFileDialog($fileWrapper) {
    $fileWrapper.find('.file-input').trigger('click');
  }

  function removeFile($fileWrapper) {
    $fileWrapper.find('.add-file').text($fileWrapper.find('.add-file').data('title'));
    $fileWrapper.find('.file-value').val('');
  }

  function selectFile($fileInput, e) {
    var $fileWrapper = $fileInput.closest('.file-wrapper');
    var uploadCallbackName = $fileInput.data('upload_callback_name');
    var uploadRoute = $fileInput.data('upload_route');

    var fileCount = 0;
    $.each(e.target.files, function () {
      fileCount++;
    });

    blockElement($fileWrapper);
    $.each(e.target.files, function (key, value) {
      var data = new FormData();
      data.append('file', value);
      data.append('file_name', $fileInput.data('file_name'));
      $.ajax({
        url: uploadRoute,
        type: 'POST',
        data: data,
        cache: false,
        dataType: 'json',
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (res) {
          fileCount--;
          if (fileCount === 0) {
            unBlockElement($fileWrapper);
          }

          if (typeof res.error === 'undefined') {
            if (uploadCallbackName) {
              var fn = window[uploadCallbackName];
              if (typeof fn === 'function') {
                fn(res, $fileInput);
              }
            } else {
              $fileWrapper.find('.add-file').text(res.data.name);
              $fileWrapper.find('.file-value').val(res.data.file_id);
              $fileWrapper.find('.download-file').attr('href', res.data.file_url);
            }
          }
        },

        error: function (/*jqXHR, textStatus*/) {
          fileCount--;
          if (fileCount === 0) {
            $fileWrapper.find('.add-file').show();
            $fileWrapper.find('.upload-progress').hide();
          }
        }
      });
    });

    $fileInput.val('');
  }

  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_fileUpload.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('file-upload-init')) {
          return;
        }

        $this.addClass('file-upload-init');

        $this.on('click', '.add-file', function () {
          openFileDialog($this);
          return false;
        });

        $this.on('change', '.file-input', function (e) {
          selectFile($(this), e);
          return false;
        });

        $this.on('click', '.remove-file', function (e) {
          removeFile($this, e);
          return false;
        });
      });
    }
  };

  $.fn.k2_fileUpload = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_fileUpload');
    }

  };

  $.fn.k2_fileUpload.defaults = {};

})(jQuery);
